import { userManager } from './user-manager';

const TRANSIENT_PATHS = ['/auth/redirect', '/logout/redirect', '/login'];

let isSigningOut = false;

export const triggerSignin = (): void => {
  if (isSigningOut) {
    return;
  }
  isSigningOut = true;

  const path = window.location.pathname;
  if (!TRANSIENT_PATHS.includes(path)) {
    sessionStorage.setItem('post-auth-redirect', path + window.location.search);
  }

  void userManager.removeUser().finally(() => {
    void userManager.signinRedirect();
  });
};
